export const Pay_Manual_Only = 83;
export const Pay_Rights = 61;
export const View_Pay = 84;
export const Remit_Rights = 33;
export const AgentNet_Admin = 36;
export const FRAUD_VALIDATION = 141;
export const FRAUD_VALIDATION_READ_ONLY = 142;
export const VIEW_AGENT_DASHBOARD_PREMIUM_REVENUE = 46;
